import { ContentContainer as StyledContentContainer } from './styles';

const ContentContainer: React.FC<any> = ({
    ...props
}) => {
    return <StyledContentContainer {...props}/>
}

export default ContentContainer;